import { swSettings } from "app/common/services/swSettings";
import { PureComponent } from "react";
import DurationService from "app/services/DurationService";
import { getRecentByType, getSavedProperties } from "pro-features/pages/module start page/src/utils";

import { DefaultFetchService } from "../../services/fetchService";
import { fetchSavedProperties } from "../research-homepage/pageResources";
import _ from "lodash";
import CountryService from "app/services/CountryService";
import { RecentService } from "app/services/recent/recentService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { i18nFilter, translate } from "app/filters/i18nFilter";

export const transformRecentAnalysis = (recents, countryService, swNavigator, i18n) => {
    return recents.map((item) => {
        const pageState = swNavigator.getStateForPageId(item.data.pageId);
        if (!pageState) {
            return { ...item, subtitle: "" };
        }
        const countryCode =
            item.data.country ||
            (_.isFunction(pageState.configId)
                ? swSettings.components[pageState.configId()].defaultParams.country
                : swSettings.components[pageState.configId].defaultParams.country);
        return {
            ...item,
            subtitle: `${i18n(pageState.pageTitle)}, ${countryService.countriesById[countryCode].text},
         ${DurationService.getDurationData(item.data.duration, null).forWidget}`,
        };
    });
};

abstract class BaseAnalysisStartPageContainer extends PureComponent<any, any> {
    public fetchService: any;
    public swNavigator: any;
    public countryService: any;
    public durationService: any;
    public swSettings: any;
    public i18n: any;
    public type: string;
    public recents: any;
    public savedProperties: any;

    constructor(props) {
        super(props);
        this.fetchService = DefaultFetchService.getInstance();
        this.swNavigator = proNavigator;
        this.countryService = CountryService;
        this.durationService = DurationService;
        this.swSettings = swSettings;
        this.i18n = i18nFilter;
        this.recents = {};
        this.savedProperties = {};
        this.state = {
            autocompleteLoading: false,
            autocompleteFocused: false,
            loading: true,
            empty: {
                saved: false,
                recents: false,
                kwGroups: false,
            },
        };
    }

    public async componentDidMount() {
        const savedPropertiesCall = fetchSavedProperties();
        const recentsResults = RecentService.getRecents();

        const [savedPropertiesResults] = [await savedPropertiesCall];

        const savedProperties = savedPropertiesResults.payload;

        const recents = getRecentByType(recentsResults, this.type);

        this.recents = transformRecentAnalysis(recents, this.countryService, this.swNavigator, this.i18n);
        this.savedProperties = getSavedProperties(savedProperties, this.type);
        this.setState((state) => ({
            loading: false,
            empty: {
                saved: !(this.savedProperties.length > 0),
                recents: !(this.recents.length > 0),
            },
        }));
    }

    public abstract getAnalysisType();
    public abstract render();

    public onAutocompleteBlur = (query) => {
        this.setState((state) => ({
            autocompleteFocused: false,
        }));
    };

    public onAutocompleteFocus = () => {
        this.setState((state) => ({
            autocompleteFocused: true,
        }));
    };

    public onAutocompleteItemClick = (url) => () => {
        window.location.href = url;
    };
}
